/**
 * 直接搜索Main可以查看当前页面的主要内容
 */
import React, { useEffect } from "react";
import withLayout from "../../../src/layouts/withLayout";
import AskPriceV2 from "./index.v2.1";
// import AskPriceV22 from "./index.v2.2";
import AskPriceKindType from "./kindType";
import qs from "qs";

const types = ["checkPrice", "installment", "subscribe", "currentCar", "tradeIn", "insurance", "bookDrive"];
export enum EPriceInquiryType {
  /** 常规 */
  NORMAL = "",
  /** 查底价(单车) */
  PRICE = "single",
  CHECKPRICE = "checkPrice",
  /** 查底价(多车) */
  PRICEMULTIPLE = "multiple",
  /** 汰舊換新 */
  PRICETRADEIN = "tradeIn",
  /** 高价卖车 */
  PRICEINSTALLMENT = "sellCar",
  /** 购车保险 */
  PRICEINSURANCE = "insurance",
  /** 查现车 */
  PRICECURRENTCAR = "currentCar",
  /** 預約試駕 */
  SUBSCRIBE = "subscribe",
  /** 广告落地页 */
  AD = "ad",
  /** 购车菜单 */
  BUY_CAR_MENU = "buyCarMenu",
  /** 分期购车 */
  INSTALLMENT = "installment",
  /** 预约试驾 */
  BOOKDRIVE = "bookDrive",
}

const getDescType = (type: string) => {
  return {
    [EPriceInquiryType.PRICE]: "查成交價",
    [EPriceInquiryType.INSTALLMENT]: "分期購車",
    [EPriceInquiryType.PRICEINSURANCE]: "購車保險",
    [EPriceInquiryType.SUBSCRIBE]: "預約試駕",
    [EPriceInquiryType.PRICECURRENTCAR]: "現車查詢",
    [EPriceInquiryType.PRICETRADEIN]: "汰舊換新",
    [EPriceInquiryType.BUY_CAR_MENU]: "詢購車菜單",
    [EPriceInquiryType.CHECKPRICE]: "查成交價",
  }[type];
};

const AskPricePage: React.FC<any> = ({}) => {
  let { kindType } = qs.parse(location.search, { ignoreQueryPrefix: true }) as { kindType: string };

  useEffect(() => {
    const inquiryType = getDescType(kindType) || "一鍵詢價";
    window.inquiryType = inquiryType;
  }, []);
  return <div>{types.includes(kindType) ? <AskPriceKindType /> : <AskPriceV2 abTest='B-一鍵詢價' />}</div>;
};

withLayout({
  cmp: <AskPricePage />,
  params: {
    AdTopBanner: false,
    nav: "DefaultFixedNav",
    footer: "Footer",
    needRTBH: true,
  },
});
